import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({endPoint: `RequestResetPassword`, method: 'POST', body, token})
}
